var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Upload Video")]),
      _c(
        "md-layout",
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "90", "md-flex-small": "80" } },
            [
              _c(
                "md-input-container",
                {
                  class: {
                    "md-input-invalid":
                      _vm.formSubmitted && _vm.validations.fileUploaded.$invalid
                  }
                },
                [
                  _c("label", [_vm._v("Select file to upload")]),
                  _c("md-file", {
                    attrs: {
                      id: "input-video",
                      accept: "video/*,.mkv",
                      disabled: _vm.uploadDisabled
                    },
                    on: { selected: _vm.onFileSelected },
                    model: {
                      value: _vm.fileName,
                      callback: function($$v) {
                        _vm.fileName = $$v
                      },
                      expression: "fileName"
                    }
                  }),
                  !_vm.validName
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          "The video file name should only contain letters and numbers"
                        )
                      ])
                    : !_vm.validFormat
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          "You must select a valid video (the valid ones are: MOV, MP4, WEBM, AVI, WMV, MKV)"
                        )
                      ])
                    : _vm.formSubmitted &&
                      !_vm.validations.fileUploaded.required
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("You must select a video and click to upload it")
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "md-layout",
            {
              attrs: {
                "md-flex": "10",
                "md-flex-small": "20",
                "md-align": "center"
              }
            },
            [
              _c(
                "div",
                { staticClass: "uploader" },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button md-fab",
                      class: { "md-primary": _vm.done },
                      attrs: { id: "upload-video", disabled: _vm.done },
                      on: { click: _vm.upload }
                    },
                    [
                      !_vm.done && !_vm.uploading
                        ? _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-cloud-upload-alt" }
                          })
                        : _vm._e(),
                      _vm.done
                        ? _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-check" }
                          })
                        : _vm._e(),
                      !_vm.done && _vm.uploading
                        ? _c("span", { staticClass: "uploading" }, [
                            _vm._v("% " + _vm._s(_vm.progress))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.progress > 0 && !_vm.done
                    ? _c(
                        "md-theme",
                        { attrs: { "md-name": "blue" } },
                        [
                          _c("md-spinner", {
                            attrs: {
                              "md-size": 74,
                              "md-stroke": 2.2,
                              "md-progress": _vm.progress
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.uploading
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-primary cancel-button",
                      on: { click: _vm.cancelUpload }
                    },
                    [_vm.uploading ? _c("span", [_vm._v("Cancel")]) : _vm._e()]
                  )
                : _vm._e(),
              !_vm.uploading && _vm.file && !_vm.done
                ? _c("span", { staticClass: "centered" }, [
                    _vm._v("Click to upload")
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-503d2f65", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-503d2f65","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/upload/VideoUploader.vue
// module id = 961
// module chunks = 0